<template>
  <div class="popup-block popup-block-settings" v-if="profile">
    <div class="w-100">
      <HeaderPopup :showBack="true" :showLock="true" v-on:goback="$router.push('/popup')"
                   v-on:startkidsmode="lockDeviceWithProfile"/>
      <div class="mt-2 mb-2 flex-v-center w-100 popup-menu">
        <img :src="profile.avatar || $avatars[profile.defaultAvatarId || 13]" alt="avatar" class="avatar-small mr-1">
        <span class="text-bold text-md text-uppercase">{{ profile.kidName || 'Kid' }}’s settings</span>
      </div>
      <div class="popup-menu">
        <Menu
            v-for="(component) in menu"
            v-bind="component"
            :key="component.key"
            v-on:openmenuitem="openMenuItem"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import saveSetting from '../components/mixins/saveSetting'
import {reportEvent} from "@/helpers/utils";
import HeaderPopup from "@/components/HeaderPopup";
import Menu from "@/components/Menu";

export default {
  name: 'PopupProfileSettings',
  components: {
    HeaderPopup,
    Menu
  },
  mixins: [saveSetting],
  data: function () {
    return {
      isAndroid: window.Android,
      profileName: this.$route.query.id,
      menu: [
        {
          key: 1,
          titleID: 'Statistics',
          title: this.$lang.messages.menu.statistics.title,
          text: this.$lang.messages.menu.statistics.description,
          icon: 'statistic.svg',
        },
        {
          key: 2,
          titleID: 'ProfileLimits',
          title: 'Screen time',
          text: this.$lang.messages.menu.settings.description,
          icon: 'settings.svg'
        },
        {
          key: 3,
          titleID: 'Sites',
          title: this.$lang.messages.menu.sites.title,
          text: this.$lang.messages.menu.sites.description,
          icon: 'sites.svg'
        },
        {
          key: 4,
          titleID: 'Backgrounds',
          title: this.$lang.messages.menu.themes.title,
          text: this.$lang.messages.menu.themes.description,
          icon: 'themes.svg'
        },
        {
          key: 5,
          titleID: 'ProfileSettings',
          title: 'Profile',
          text: this.$lang.messages.menu.settings.description,
          icon: 'settings.svg'
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      profileAtCurrentDevice: 'profileAtCurrentDevice',
    }),
    ...mapState({
      isPremium: state => state.accountData.isPremium,
      profiles: state => state.accountData.profiles,
      currentDeviceID: state => state.currentDeviceID,
    }),
    profile(){
      return this.profiles[this.profileName]
    }
  },
  mounted() {
    if(!Object.keys(this.profiles).find(item => item === this.profileName)){
      this.$router.push('/popup')
    }
  },
  methods: {
    lockDeviceWithProfile() {
      reportEvent('startKidsMode', {
        isRemote: false,
      });
      this.saveDeviceSettings(this.currentDeviceID,
          {
            locked: true,
            currentProfileID: this.profileName,
          });
    },
    openMenuItem(item){
      this.$router.push({path: 'profile', query: {id: this.profileName, menuItem: item, popup: true}})
    },
  }
}
</script>

<style lang="scss">
@import "../assets/styles/popup";
</style>
